/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Featureddiscounts_Until1Inputs */

const id_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hingga`)
};

const ms_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sehingga`)
};

const da_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`indtil`)
};

const de_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bis`)
};

const en_us2_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`until`)
};

const es_es2_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hasta`)
};

const es_mx2_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hasta`)
};

const fil_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hanggang`)
};

const fr_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jusqu'au`)
};

const it_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fino al`)
};

const hu_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-ig`)
};

const nl_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tot`)
};

const no_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`til`)
};

const pl_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`do`)
};

const pt_br2_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`until`)
};

const pt_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`até`)
};

const ro_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`până`)
};

const fi_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`asti`)
};

const sv_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tills`)
};

const vi_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cho đến`)
};

const tr_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kadar`)
};

const cs_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`do`)
};

const bg_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`до`)
};

const ru_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`до`)
};

const uk_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`до`)
};

const ar_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حتى`)
};

const hi_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तक`)
};

const th_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จนถึง`)
};

const ja_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まで`)
};

const zh_cn2_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`until`)
};

const zh_hant1_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`until`)
};

const ko_components_featureddiscounts_until1 = /** @type {(inputs: Components_Featureddiscounts_Until1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`until`)
};

/**
* | output |
* | --- |
* | "until" |
*
* @param {Components_Featureddiscounts_Until1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_featureddiscounts_until1 = /** @type {((inputs?: Components_Featureddiscounts_Until1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Featureddiscounts_Until1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_featureddiscounts_until1(inputs)
	if (locale === "ms") return ms_components_featureddiscounts_until1(inputs)
	if (locale === "da") return da_components_featureddiscounts_until1(inputs)
	if (locale === "de") return de_components_featureddiscounts_until1(inputs)
	if (locale === "en-US") return en_us2_components_featureddiscounts_until1(inputs)
	if (locale === "es-ES") return es_es2_components_featureddiscounts_until1(inputs)
	if (locale === "es-MX") return es_mx2_components_featureddiscounts_until1(inputs)
	if (locale === "fil") return fil_components_featureddiscounts_until1(inputs)
	if (locale === "fr") return fr_components_featureddiscounts_until1(inputs)
	if (locale === "it") return it_components_featureddiscounts_until1(inputs)
	if (locale === "hu") return hu_components_featureddiscounts_until1(inputs)
	if (locale === "nl") return nl_components_featureddiscounts_until1(inputs)
	if (locale === "no") return no_components_featureddiscounts_until1(inputs)
	if (locale === "pl") return pl_components_featureddiscounts_until1(inputs)
	if (locale === "pt-BR") return pt_br2_components_featureddiscounts_until1(inputs)
	if (locale === "pt") return pt_components_featureddiscounts_until1(inputs)
	if (locale === "ro") return ro_components_featureddiscounts_until1(inputs)
	if (locale === "fi") return fi_components_featureddiscounts_until1(inputs)
	if (locale === "sv") return sv_components_featureddiscounts_until1(inputs)
	if (locale === "vi") return vi_components_featureddiscounts_until1(inputs)
	if (locale === "tr") return tr_components_featureddiscounts_until1(inputs)
	if (locale === "cs") return cs_components_featureddiscounts_until1(inputs)
	if (locale === "bg") return bg_components_featureddiscounts_until1(inputs)
	if (locale === "ru") return ru_components_featureddiscounts_until1(inputs)
	if (locale === "uk") return uk_components_featureddiscounts_until1(inputs)
	if (locale === "ar") return ar_components_featureddiscounts_until1(inputs)
	if (locale === "hi") return hi_components_featureddiscounts_until1(inputs)
	if (locale === "th") return th_components_featureddiscounts_until1(inputs)
	if (locale === "ja") return ja_components_featureddiscounts_until1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_featureddiscounts_until1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_featureddiscounts_until1(inputs)
	return ko_components_featureddiscounts_until1(inputs)
});
export { components_featureddiscounts_until1 as "components.featuredDiscounts.until" }